var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDeviceButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9160",
    "data-name": "Group 9160",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 87,
    viewBox: "0 0 96 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_67_66",
    "data-name": "Component 67 \\u2013 66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 73,
    height: 73,
    rx: 8,
    fill: "#005637"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8765",
    "data-name": "Group 8765",
    transform: "translate(-1566.466 -930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_8878",
    "data-name": "Path 8878",
    transform: "translate(1585 942.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10002",
    "data-name": "Path 10002",
    d: "M32.609,44.677,11.336,42.651l-.024,0h-.024A11.006,11.006,0,0,1,.282,31.643v-.062l-.015-.06L-4.739,11.644A69.682,69.682,0,0,1,.951,6.125C5.239,2.445,8.813.5,11.289.5H31.425A11.006,11.006,0,0,1,42.432,11.506V31.643C42.432,37.258,33.849,43.766,32.609,44.677Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10003",
    "data-name": "Path 10003",
    d: "M11.289,1c-1.641,0-4.708.954-10,5.5a69.392,69.392,0,0,0-5.473,5.286L.782,31.519v.124A10.518,10.518,0,0,0,11.289,42.149h.047l21.129,2.012a42.126,42.126,0,0,0,4.682-4.082c3.13-3.194,4.784-6.111,4.784-8.436V11.506A10.518,10.518,0,0,0,31.425,1H11.289m0-1H31.425A11.506,11.506,0,0,1,42.932,11.506V31.643c0,6.355-10.182,13.55-10.182,13.55l-21.46-2.043A11.506,11.506,0,0,1-.218,31.643L-5.289,11.506S4.934,0,11.289,0Z",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4349",
    "data-name": "Rectangle 4349",
    transform: "translate(1578 947)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    transform: "translate(1586 956)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 8,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    transform: "translate(1586 970)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4356",
    "data-name": "Rectangle 4356",
    transform: "translate(1612 970)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4352",
    "data-name": "Rectangle 4352",
    transform: "translate(1586 975)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4355",
    "data-name": "Rectangle 4355",
    transform: "translate(1612 975)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4353",
    "data-name": "Rectangle 4353",
    transform: "translate(1593 980)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4354",
    "data-name": "Rectangle 4354",
    transform: "translate(1612 980)",
    fill: "#fff",
    stroke: "#113252",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon_navigation_close_24px",
    "data-name": "icon/navigation/close_24px",
    transform: "translate(53 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    fill: "#f6f6f6",
    stroke: "#545454",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 41,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 33,
    height: 33,
    transform: "translate(5 5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M20.364,2.051,18.313,0,10.182,8.131,2.051,0,0,2.051l8.131,8.131L0,18.313l2.051,2.051,8.131-8.131,8.131,8.131,2.051-2.051-8.131-8.131Z",
    transform: "translate(21.5 7.101) rotate(45)",
    fill: "#787878"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeviceButton);
export default __webpack_public_path__ + "static/media/AddDeviceButton.d1e5ae37da926ca9b8d72a64a42733fa.svg";
export { ForwardRef as ReactComponent };